module.exports = __webpack_public_path__ + "img/announcement.61c12952.jpg";